import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Eason is a Backend Engineer and also be the volunteer and speaker in the DDDTW community. Enjoy reading, jogging, and study financial statements for US Stocks, sometimes write some article to share information.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      